import { deDE, enUS } from '@mui/x-date-pickers/locales';

const LANG = {
    de: { code: 'DE', name: 'german', i18nCode: 'de', datePickerLocale: deDE },
    en: { code: 'EN', name: 'english', i18nCode: 'en', datePickerLocale: enUS },
};

// Accepts 'de', 'en' and regional variants such as 'en-US' or 'en_GB'; anything else is German.
const findLang = (key) => {
    const primary = String(key || '')
        .toLowerCase()
        .split(/[-_]/)[0];
    return LANG[primary] || LANG.de;
};

export { LANG, findLang };
